<template>
  <div class="lock-event" data-t="lock-event">
    <div class="top">
      <NuxtI18nLink :to="event.url ?? '/'" class="logos">
        <CompetitorLogo
          :competitor="event.home"
          logo-size="medium"
          class="logo first"
        />
        <CompetitorLogo
          :competitor="event.away"
          logo-size="medium"
          class="logo second"
        />
      </NuxtI18nLink>
      <CompetitorNames :event="event" compact size="m" class="names" />
      <div v-if="isLive" class="scores" data-t="live-score">
        <div class="scores-item">
          {{ event.match?.stats?.home_score }}
        </div>
        <div class="scores-item">
          {{ event.match?.stats?.away_score }}
        </div>
      </div>
    </div>
    <div class="bottom">
      <EventStatusBar :event="event" size="m" />
      <button
        class="pin-button"
        :class="{ locked }"
        data-t="pin-button"
        @click="emit('toggle', !locked)"
      >
        <StIcon class="pin-icon" name="pin-solid" :size="16" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TSportEvent } from 'markets-store'

const props = defineProps<{
  event: TSportEvent
  locked?: boolean
}>()

const emit = defineEmits<{
  toggle: [value: boolean]
}>()

const isLive = computed(() => props.event.status)
</script>

<style scoped>
.lock-event {
  display: block;
  width: 224px;
  background: radial-gradient(
      400.17% 111.8% at 100% 0%,
      #2d2d39 0%,
      #1f1f29 100%
    ),
    var(--background-primary);
  border-radius: var(--border-radius-150);

  &:hover {
    background: radial-gradient(
        400.17% 111.8% at 100% 0%,
        #393946 0%,
        #1f1f29 100%
      ),
      var(--background-primary);
  }
}

.top {
  display: flex;
  gap: var(--spacing-075);
  padding: var(--spacing-075) var(--spacing-075) var(--spacing-025)
    var(--spacing-100);
}

.bottom {
  display: flex;
  gap: var(--spacing-100);
  align-items: center;
  justify-content: space-between;

  padding: 0 var(--spacing-050) var(--spacing-050) var(--spacing-100);
}

.logos {
  display: flex;
  align-items: center;
  width: 70px;
}

.first {
  z-index: 1;
  border-right: var(--border-width-boldest) solid var(--background-primary);
}

.second {
  position: relative;
  left: -2px;
}

.names {
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  font: var(--desktop-text-sm-medium);
}

.pin-button {
  all: unset;

  cursor: pointer;

  padding: var(--spacing-050);

  line-height: 0;
  color: var(--text-tertiary);

  opacity: 0;

  transition:
    opacity 0.15s,
    color 0.15s;

  &.locked {
    color: var(--text-link);
    opacity: 1;
  }

  &:hover {
    .pin-icon {
      background-color: var(--button-primary-hover);
    }
  }
}

.lock-event:hover .pin-button {
  opacity: 1;
}

.scores {
  display: flex;
  flex-direction: column;
  align-items: center;

  font: var(--desktop-text-sm-medium);
  color: var(--text-primary);
}

.scores-item {
  min-width: 20px;
  text-align: center;
}
</style>
